var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { DinPlayerProvider, PlayMode, useDinPlayer } from 'hx-din-test-2';
export var DinPlayer = function (_a) {
    var children = _a.children;
    var dinPlayer = useDinPlayer({
        audioSetName: 'fr_fr_digits',
        playMode: PlayMode.BinauralOutOfPhase,
    });
    return _jsx(DinPlayerProvider, __assign({}, dinPlayer, { children: children }));
};
